module.exports = __webpack_public_path__ + "img/(8).0a683efa.jpg";